module.exports = __webpack_public_path__ + "img/bg_green_popular.4e2a26f8.png";